import apiClient from './apiClient';

export interface AppSettings {
  emailEnabled: boolean;
}

export const settingsService = {
  async getSettings(): Promise<AppSettings> {
    const response = await apiClient.get('/api/settings');
    return response.data;
  },

  async updateSetting(key: string, value: string): Promise<void> {
    await apiClient.put(`/api/settings/${key}`, { value });
  },
};
